import React, { useState, useEffect } from 'react';
import { TextField, FormControl } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { debounce } from '@mui/material/utils';

const LazyAutocomplete = ({ field, language, handleChange, index, commonProps, handleOnBlur }) => {
    
    const [options, setOptions] = useState(field.Options.slice(0, 200));
    const [inputValue, setInputValue] = useState(null);
    const [selectedOption, setSelectedOption] = useState(() => {
        // First check if there's a CustomValue
        if (field.CustomEntry && field.CustomValue) {
            return { OptionId: field.CustomValue, DescriptionEN: field.CustomValue, DescriptionEL: field.CustomValue };
        }
        // Otherwise check Options
        return field.Options.find(opt => opt?.OptionId === field.Value) || null;
    });

    const fetchOptions = debounce((searchTerm) => {
        if (!searchTerm) {
            setOptions(field.Options.slice(0, 200));
            return;
        }

        const filtered = field.Options.filter((opt) => {
            const description = (language === 'en' ? opt.DescriptionEN : opt.DescriptionEL) ?? '';
            return description.toLowerCase().includes((searchTerm ?? '').toLowerCase());
        });

        setOptions(filtered.slice(0, 200));
    }, 300);

    useEffect(() => {
        fetchOptions(inputValue);
    }, [inputValue]);

    useEffect(() => {
        if (field.CustomEntry && field.CustomValue) {
            setSelectedOption({ OptionId: field.CustomValue, DescriptionEN: field.CustomValue, DescriptionEL: field.CustomValue });
        } else {
            const found = field.Options.find(opt => opt?.OptionId === field.Value) || null;
            setSelectedOption(found);
        }
    }, [field.Value, field.CustomValue, field.CustomEntry, field.Options]);

    return (
        <FormControl fullWidth>
            <Autocomplete
                options={options}
                value={selectedOption}
                disabled={field.readonly === true || field.readonly === 'true'}
                getOptionLabel={(opt) => {
                    if (typeof opt === 'string') return opt;
                    return (language === 'en' ? opt.DescriptionEN : opt.DescriptionEL);
                }}
                onInputChange={(event, newInputValue) => {                    
                    setInputValue(newInputValue);
                    // When user types in freeSolo mode, update selectedOption immediately
                    if (field.CustomEntry && newInputValue) {
                        setSelectedOption({ OptionId: newInputValue, DescriptionEN: newInputValue, DescriptionEL: newInputValue });
                    }
                }}
                onChange={(event, newValue) => {
                    setSelectedOption(newValue || null);
                }}
                onBlur={(data) => {
                    if (field.CustomEntry && typeof selectedOption === 'object' && selectedOption?.DescriptionEN === selectedOption?.OptionId) {
                        handleOnBlur(index, selectedOption?.OptionId, true);
                    } else {
                        field.CustomValue = null
                        const optionId = selectedOption?.OptionId || null;
                        handleOnBlur(index, optionId, false);
                    }
                }}
                freeSolo={field.CustomEntry}
                filterOptions={(x) => x}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        {...commonProps}
                        variant="outlined"
                    />
                )}
            />
        </FormControl>
    );
};

export default LazyAutocomplete;
